import { customElement, noShadowDOM } from 'solid-element'
import type { Component } from 'solid-js'
import { StoryDefinition, StoryMetadata } from './stories'
import { render as renderSolid } from 'solid-js/web'

export function register<T extends object = {}>(name: string, module: string, defaultProps: T, component: Component<T>) {
    window.solidComponents = window.solidComponents || {}

    window.solidComponents[name] = {
        name,
        module,
        component,
        defaultProps,
        metadata: undefined,
        stories: {}
    }

    customElement(name, defaultProps, (props: T) => {
        noShadowDOM()
        return component(props as T)
    })
}

export function render<T extends object = {}>(component: Component<T>, props: T, element: HTMLElement) {
    renderSolid(() => component(props), element || document.body)
}

export interface ComponentDefinition {
    name: string,
    component: Component<any>,
    defaultProps: any,
    module: string,
    metadata?: () => StoryMetadata<Component<any>>
    stories: Record<string, () => StoryDefinition<Component>>,
}

declare global {
    interface Window {
        solidComponents: Record<string, ComponentDefinition>
    }
}